import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';
import CounterUp from '../../component/counterup/CounterUp';


const CounterUpOne = () => {
    return (
        <div className="section section-padding bg-color-dark">
            <div className="container">
            <SectionTitle 
                    subtitle="Proven Results"
                    title="Real projects, measurable impact, and happy clients across industries"
                    description="We partner with startups and growing businesses to design and build products that perform. From strategy and UI/UX to development and launch, our team delivers reliable solutions with clear outcomes better user experience, faster workflows, and stronger growth."
                    textAlignment="heading-light"
                    textColor=""
                />
                <div className="row">
                    <CounterUp colSize="col-lg-4 col-6" layoutStyle="" evenTopMargin="" />
                </div>
            </div>
        </div>
    )
}


export default CounterUpOne;